export enum DeliveryAutorizationEnum {
    PENDING = 0,
    AUTORIZED = 1
}
